import {HttpHeaders} from "@angular/common/http";

export const httpJsonHeaders = (): HttpHeaders => new HttpHeaders().set("Content-Type", "application/json; charset=utf-8");
